import { Box, Modal, ScrollArea, Table, Text } from '@mantine/core';
import type { UseQueryResult } from 'react-query';
import { NoDataFoundMessage } from '../../../components/DataTable';
import { LoadingRows } from '../../../components/LoadingRows';
import { Title } from '../../../components/Title';
import type { ApiResponse } from '../../../util/types/Response';
import { undefinedCheck } from '../../../util/undefinedCheck';
import type { BranchDto } from '../../branches/types/BranchTypes';
import { KeyedRow } from '../../../components/KeyedRow';

interface BranchesModalProps {
	close: () => void;
	isOpened: boolean;
	query: UseQueryResult<ApiResponse<BranchDto[]>, unknown>;
}

export function BranchesModal({ close, isOpened, query }: BranchesModalProps) {
	return (
		<>
			<Modal
				opened={isOpened}
				onClose={close}
				title={
					<Text size={'1rem'} fw={500} pb={0}>
						Branches
					</Text>
				}
				w={100}
				withCloseButton={true}
				size={'lg'}
				centered
			>
				<ScrollArea w={'100%'} h={'40vh'}>
					<Table stickyHeader striped highlightOnHover>
						<Table.Thead>
							<KeyedRow>
								<Table.Th>
									<Title label={'Name'} />
								</Table.Th>
								<Table.Th>
									<Title label={'Area'} />
								</Table.Th>
								<Table.Th>
									<Title label={'Post Code'} />
								</Table.Th>
								<Table.Th>
									<Title label={'Telephone No.'} />
								</Table.Th>
								<Table.Th>
									<Title label={'Email'} />
								</Table.Th>
							</KeyedRow>
						</Table.Thead>
						<Table.Tbody>
							{!query.isLoading ? (
								<>
									{query.data?.value.map((branch) => (
										<KeyedRow>
											<Table.Td>{undefinedCheck(branch.name)}</Table.Td>
											<Table.Td>{undefinedCheck(branch.area)}</Table.Td>
											<Table.Td>{undefinedCheck(branch.postCode)}</Table.Td>
											<Table.Td>{undefinedCheck(branch.phone)}</Table.Td>
											<Table.Td>{undefinedCheck(branch.email)}</Table.Td>
										</KeyedRow>
									))}
								</>
							) : (
								<LoadingRows rows={20} columnSpan={10} />
							)}
						</Table.Tbody>
					</Table>
					<Box w={'100%'}>
						{query.data?.value?.length === 0 && <NoDataFoundMessage />}
					</Box>
				</ScrollArea>
			</Modal>
		</>
	);
}
